import {Helmet} from "react-helmet";

export default function Sponsor () {

    return (

    <>
    <Helmet>
        <title>Make.rs | Sponsor</title>
    </Helmet>

    <div className='px-2 md:px-20'>
        <p className='text-center text-black text-4xl font-bold'>Promote with Make.rs</p>
        <br/><br/>
        <div className='text-xl'>
        <p>We’re excited to partner with makers, creators, and supporters who want to gain visibility while helping strengthen the maker community.</p>
        <br/>
        <p className='font-bold'>Sponsorship Opportunities</p>
        <p>Our pinned content opportunities give you prime visibility with our engaged maker community. Your sponsored post appears at the very top of our “Everyone” feed, ensuring maximum exposure to makers actively looking for tools, resources, and inspiration.</p>
        <br />
        <p className="">💎 <span className="italic">Only one sponsored post slot is available each month - secure yours early!</span></p>
        <br />
        <p className='font-bold'>Pricing</p>
        <p>Sponsored posts are just <strong>$100/month</strong>. Your post or project will be pinned at the top of our main feed for one month, clearly marked as sponsored and highlighted with our signature purple border for maximum visibility.</p>
        <br />
        <p className='font-bold'>Get in Touch</p>
        <p>Contact <a href="mailto:cezar@make.rs" className='underline text-blue-600 hover:text-blue-800'>cezar@make.rs</a></p>
        <br />
        <p className='text-gray-600'>All sponsored content is clearly marked to maintain transparency with our community.</p>
        <br />
        </div>
    </div>
    </>
    );
}